(function () {
  'use strict';

  class FooterNewsletter extends HTMLElement {
    constructor() {
      super();
      this.onOpen = this.onOpen.bind(this);
      this.onClose = this.onClose.bind(this);
      this.onOverlayClick = this.onOverlayClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.isClosing = false;
      this.closeTimer = null;
      this.lastFocusedElement = null;
    }

    connectedCallback() {
      this.openButton = this.querySelector('[data-sd-footer-newsletter-open]');
      this.overlay = this.querySelector('[data-sd-footer-newsletter-overlay]');
      this.dialog = this.querySelector('[role="dialog"]');
      this.closeButtons = this.querySelectorAll('[data-sd-footer-newsletter-close]');
      this.emailInput = this.querySelector('.sd-footer__newsletter-input');
      this.successMessage = this.querySelector('.sd-footer__newsletter-message--success');
      this.errorMessage = this.querySelector('.sd-footer__newsletter-message--error');
      this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');
      this.onMediaQueryChange = this.onMediaQueryChange.bind(this);

      if (this.overlay && this.overlay.parentElement !== document.body) {
        document.body.appendChild(this.overlay);
      }

      this.openButton?.addEventListener('click', this.onOpen);
      this.closeButtons.forEach((button) => button.addEventListener('click', this.onClose));
      this.overlay?.addEventListener('click', this.onOverlayClick);
      this.mobileMediaQuery.addEventListener('change', this.onMediaQueryChange);

      if (
        this.isMobileViewport() &&
        (this.successMessage ||
          this.errorMessage ||
          (this.emailInput && this.emailInput.getAttribute('aria-invalid') === 'true'))
      ) {
        this.onOpen();
      }
    }

    disconnectedCallback() {
      this.openButton?.removeEventListener('click', this.onOpen);
      this.closeButtons?.forEach((button) => button.removeEventListener('click', this.onClose));
      this.overlay?.removeEventListener('click', this.onOverlayClick);
      this.mobileMediaQuery?.removeEventListener('change', this.onMediaQueryChange);
      document.removeEventListener('keydown', this.onKeydown);
      window.clearTimeout(this.closeTimer);
      document.body.classList.remove('sd-footer-newsletter-open');
      this.overlay?.remove();
    }

    isMobileViewport() {
      return this.mobileMediaQuery.matches;
    }

    onMediaQueryChange() {
      if (!this.isMobileViewport()) {
        this.onClose();
      }
    }

    onOpen() {
      if (!this.overlay || this.isClosing || !this.isMobileViewport()) {
        return;
      }

      this.lastFocusedElement = document.activeElement;
      window.clearTimeout(this.closeTimer);
      this.overlay.hidden = false;
      document.body.classList.add('sd-footer-newsletter-open');
      document.addEventListener('keydown', this.onKeydown);

      requestAnimationFrame(() => {
        this.overlay.classList.add('is-open');
      });

      window.setTimeout(() => {
        const focusTarget = this.successMessage || this.emailInput || this.closeButtons[0];

        if (focusTarget) {
          focusTarget.focus();
        }
      }, 100);
    }

    onClose() {
      if (!this.overlay || this.overlay.hidden || this.isClosing) {
        return;
      }

      this.isClosing = true;
      this.overlay.classList.remove('is-open');
      document.removeEventListener('keydown', this.onKeydown);

      this.closeTimer = window.setTimeout(() => {
        this.overlay.hidden = true;
        this.isClosing = false;
        document.body.classList.remove('sd-footer-newsletter-open');

        if (this.lastFocusedElement && typeof this.lastFocusedElement.focus === 'function') {
          this.lastFocusedElement.focus();
        } else {
          this.openButton?.focus();
        }
      }, 350);
    }

    onOverlayClick(event) {
      if (event.target === this.overlay) {
        this.onClose();
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.onClose();
      }
    }
  }

  function initFooterAccordion(accordion) {
    if (!accordion || accordion.dataset.sdFooterAccordionInit === 'true') {
      return;
    }

    accordion.dataset.sdFooterAccordionInit = 'true';

    const closeOthers = accordion.dataset.sdFooterAccordionCloseOthers !== 'false';
    const items = Array.prototype.slice.call(
      accordion.querySelectorAll('[data-sd-footer-accordion-item]')
    );

    function setItemOpen(item, isOpen) {
      const toggle = item.querySelector('[data-sd-footer-accordion-toggle]');

      if (!toggle) {
        return;
      }

      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      item.classList.toggle('is-open', isOpen);
    }

    function closeAllItems() {
      items.forEach(function (item) {
        setItemOpen(item, false);
      });
    }

    items.forEach(function (item, index) {
      const toggle = item.querySelector('[data-sd-footer-accordion-toggle]');
      const panel = item.querySelector('[data-sd-footer-accordion-panel]');

      if (!toggle || !panel) {
        return;
      }

      const panelId = panel.id;

      if (panelId) {
        toggle.setAttribute('aria-controls', panelId);
      }

      toggle.addEventListener('click', function () {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          setItemOpen(item, false);
          return;
        }

        if (closeOthers) {
          closeAllItems();
        }

        setItemOpen(item, true);
      });

      setItemOpen(item, index === 0);
    });
  }

  function initFooterSection(section) {
    if (!section) {
      return;
    }

    section.querySelectorAll('[data-sd-footer-accordion]').forEach(initFooterAccordion);
  }

  function initAllFooters() {
    document.querySelectorAll('.sd-footer').forEach(initFooterSection);
  }

  if (!customElements.get('sd-footer-newsletter')) {
    customElements.define('sd-footer-newsletter', FooterNewsletter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFooters);
  } else {
    initAllFooters();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.classList.contains('sd-footer')
      ? event.target
      : event.target.querySelector('.sd-footer');

    initFooterSection(section);
  });
})();
